import glam from 'glamorous';
import React from 'react';
import { ColumnsUtils, createPureComponent } from 'module/Common';
import { ContentMultipleImages } from 'module/Model/Content';
import { MzImage } from 'module/Model/MzImage';
import { MzImageDisplay, Sizes } from 'module/View/Common';

type WrapperProps = {
  width: number;
  height: number;
};

const Wrapper = glam.div<WrapperProps>(props => ({
  overflow: 'hidden',
  width: props.width,
  height: props.height,
  display: 'flex',
  pointerEvents: 'all',
}));

type SpacerProps = {
  size: number;
};

const Spacer = glam.div<SpacerProps>(props => ({
  width: props.size,
}));

type Props = {
  item: ContentMultipleImages;
  itemIndex: number;
  cols: ColumnsUtils.ColumnsResult;
  isCover: boolean;
  waitForImage: (id: string) => void;
  imageReady: (id: string) => void;
};

export const MultipleImages = createPureComponent<Props>(
  'MultipleImages',
  ({ item, cols, isCover, waitForImage, imageReady }) => {
    const fullWidth = !isCover && ContentMultipleImages.isFullWidth(item);
    const width = fullWidth ? cols.size(cols.nbOfColumns) : cols.size(Sizes.allColumnsMinusOne(cols.nbOfColumns));
    const images = ContentMultipleImages.getImages(item);
    const ratios = images.map(img => MzImage.getRatio(img));
    const ratioSum = ratios.reduce((acc, val) => acc + val, 0);
    const availableWidth = width - (ratios.length - 1) * Sizes.smallGutter;
    const height = availableWidth / ratioSum;

    return (
      <Wrapper width={width} height={height}>
        {images
          .map((img, index) => {
            const ratio = MzImage.getRatio(img);
            const imgWidth = height * ratio;
            const imgId = img.id.toString();
            return (
              <MzImageDisplay
                annim={true}
                zoomable={true}
                key={index}
                image={img}
                size={{ height, width: imgWidth }}
                onLoad={() => imageReady(imgId)}
                onMount={() => waitForImage(imgId)}
              />
            );
          })
          .reduce((acc: Array<JSX.Element>, arrItem, arrIndex, arr) => {
            acc.push(arrItem);
            if (arrIndex < arr.length - 1) {
              acc.push(<Spacer key={`spacer-${arrIndex}`} size={Sizes.smallGutter} />);
            }
            return acc;
          }, [])}
      </Wrapper>
    );
  }
);



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/MultipleImages.tsx